import * as React from 'react'

const TripHistory = (props: { className: 'string' }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Rides history ON'>
          <g id='Group'>
            <path
              d='M 17.6889 1.13625C 17.4667 0.4725 16.8444 0 16.1111 0L 3.88889 0C 3.15556 0 2.54444 0.4725 2.31111 1.13625L 0 7.875L 0 16.875C 0 17.4938 0.5 18 1.11111 18L 2.22222 18C 2.83333 18 3.33333 17.4938 3.33333 16.875L 3.33333 15.75L 16.6667 15.75L 16.6667 16.875C 16.6667 17.4938 17.1667 18 17.7778 18L 18.8889 18C 19.5 18 20 17.4938 20 16.875L 20 7.875L 17.6889 1.13625ZM 2.5 7.71429L 3.88889 1.6875L 16.1111 1.6875L 17.5 7.71429L 2.5 7.71429Z'
              transform='translate(0 1)'
              id='Vector'
            />
            <path
              d='M 2.91667 2.5C 3.64849 2.5 4.23712 1.94 4.23712 1.25C 4.23712 0.56 3.64849 0 2.91667 0C 2.18485 0 1.59091 0.56 1.59091 1.25C 1.59091 1.94 2.18485 2.5 2.91667 2.5ZM 2.91667 3.5C 1.94621 3.5 0 3.96 0 4.875L 0.416667 4.875L 5.28646 4.875L 5.83333 4.875C 5.83333 3.96 3.88712 3.5 2.91667 3.5Z'
              transform='translate(10.833 3.571)'
              id='Vector_2'
            />
            <path
              d='M 2.91667 2.5C 3.64849 2.5 4.23712 1.94 4.23712 1.25C 4.23712 0.56 3.64849 0 2.91667 0C 2.18485 0 1.59091 0.56 1.59091 1.25C 1.59091 1.94 2.18485 2.5 2.91667 2.5ZM 2.91667 3.5C 1.94621 3.5 0 3.96 0 4.875L 0.416667 4.875L 5.28646 4.875L 5.83333 4.875C 5.83333 3.96 3.88712 3.5 2.91667 3.5Z'
              transform='translate(3.333 3.571)'
              id='Vector_3'
            />
            <ellipse
              cx='1.25'
              cy='1.286'
              rx='1.25'
              ry='1.286'
              transform='translate(2.5 11.286)'
              fill='#fff'
              id='Ellipse'
            />
            <ellipse
              cx='1.25'
              cy='1.286'
              rx='1.25'
              ry='1.286'
              transform='translate(15 11.286)'
              fill='#fff'
              id='Ellipse_2'
            />
            <line y1='-0.5' x2='6.667' y2='-0.5' transform='translate(6.667 14.714)' stroke='#fff' id='Line' />
            <g id='Ellipse 2' transform='translate(12 12)'>
              <circle cx='5.5' cy='5.5' r='5.5' fill='#fff' />
              <circle cx='5.5' cy='5.5' r='5' stroke='#37C47E' />
            </g>
            <g id='Vector_4' fillRule='evenodd' clipRule='evenodd'>
              <path
                d='M -0.375 5.5C -0.375 2.25738 2.2509 -0.375 5.4945 -0.375C 8.74286 -0.375 11.375 2.25665 11.375 5.5C 11.375 8.74335 8.74286 11.375 5.4945 11.375C 2.2509 11.375 -0.375 8.74262 -0.375 5.5ZM 1.475 5.5C 1.475 7.72389 3.27611 9.525 5.5 9.525C 7.72389 9.525 9.525 7.72389 9.525 5.5C 9.525 3.27611 7.72389 1.475 5.5 1.475C 3.27611 1.475 1.475 3.27611 1.475 5.5Z'
                transform='translate(12 12)'
                fill='#37C47E'
              />
              <path
                d='M -0.375 5.5C -0.375 2.25738 2.2509 -0.375 5.4945 -0.375C 8.74286 -0.375 11.375 2.25665 11.375 5.5C 11.375 8.74335 8.74286 11.375 5.4945 11.375C 2.2509 11.375 -0.375 8.74262 -0.375 5.5ZM 1.475 5.5C 1.475 7.72389 3.27611 9.525 5.5 9.525C 7.72389 9.525 9.525 7.72389 9.525 5.5C 9.525 3.27611 7.72389 1.475 5.5 1.475C 3.27611 1.475 1.475 3.27611 1.475 5.5Z'
                strokeWidth='0.75'
                strokeMiterlimit='8'
                transform='translate(12 12)'
                stroke='#fff'
              />
            </g>
            <g id='Vector_5' fillRule='evenodd' clipRule='evenodd'>
              <path
                d='M 0.95 -0.125L 0.95 0L 0.95 2.81632L 3.36378 4.2485L 3.47259 4.31306L 3.40672 4.42108L 2.99422 5.09758L 2.92961 5.20354L 2.82319 5.13969L -0.064312 3.40719L -0.125 3.37077L -0.125 3.3L -0.125 0L -0.125 -0.125L 0 -0.125L 0.825 -0.125L 0.95 -0.125Z'
                transform='translate(16.95 14.75)'
                fill='#37C47E'
              />
              <path
                d='M 0.95 -0.125L 0.95 0L 0.95 2.81632L 3.36378 4.2485L 3.47259 4.31306L 3.40672 4.42108L 2.99422 5.09758L 2.92961 5.20354L 2.82319 5.13969L -0.064312 3.40719L -0.125 3.37077L -0.125 3.3L -0.125 0L -0.125 -0.125L 0 -0.125L 0.825 -0.125L 0.95 -0.125Z'
                strokeWidth='0.25'
                strokeMiterlimit='8'
                transform='translate(16.95 14.75)'
                stroke='#37C47E'
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TripHistory



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/TripHistory.tsx